import { LoaderContainer, Spinner } from './Loading.styles';

const Loading = () => {
  return (
    <LoaderContainer>
      <Spinner />
    </LoaderContainer>
  );
};

export default Loading;
